/* El período de las pantallas de vales del surtidor (urea y gasoil de la base).
 *
 * Las dos eligen la ventana igual —Hoy, Ayer, 7 días, 30 días o calendario— y
 * le piden a la base el mismo corte: días ARGENTINOS. Vivían escritas adentro
 * de `routes/Urea`; con la pantalla de gasoil serían dos copias, y el día que
 * una corrigiera el corte de las 21:00 la otra seguiría mostrando la carga de
 * la noche en el día siguiente.
 *
 * Se apoya en `fechaAr` (UTC-3 fijo): «hoy» no puede depender del reloj de la
 * máquina del que mira.
 */

import { diaIsoAr, hoyAr } from "./fechaAr";

const DIA_MS = 24 * 3600 * 1000;

/* «Hace n días» en días de acá, como `YYYY-MM-DD`. Se cuenta desde el
 * mediodía de hoy en AR: restar días a la medianoche se puede caer al día
 * equivocado según cómo se arme el Date. */
export function diasAtras(n, ahora = new Date()) {
  const base = new Date(`${hoyAr(ahora)}T12:00:00-03:00`).getTime();
  return diaIsoAr(new Date(base - n * DIA_MS));
}

/* Las pestañas: cada una es un rango [desde, hasta], ambos inclusive. */
export const PESTANAS = [
  { id: "hoy", label: "Hoy", rango: () => [hoyAr(), hoyAr()] },
  { id: "ayer", label: "Ayer", rango: () => [diasAtras(1), diasAtras(1)] },
  { id: "7", label: "7 días", rango: () => [diasAtras(6), hoyAr()] },
  { id: "30", label: "30 días", rango: () => [diasAtras(29), hoyAr()] },
];

/* El instante UTC en que empieza un día argentino (`diasDespues` corre el
 * día). `fecha` en la base es timestamptz: filtrar por el texto `YYYY-MM-DD`
 * correría el corte tres horas y la carga de las 22:00 caería en el día
 * siguiente. */
export function corteUTC(dia, diasDespues = 0) {
  const t = new Date(`${dia}T00:00:00-03:00`).getTime() + diasDespues * DIA_MS;
  return new Date(t).toISOString();
}

/* El rango [desde, hasta] de días argentinos aplicado a una consulta de
 * PostgREST sobre `fecha`. `hasta` es inclusive: «hasta el 31» quiere el 31. */
export function enElRango(q, desde, hasta, campo = "fecha") {
  let r = q;
  if (desde) r = r.gte(campo, corteUTC(desde));
  if (hasta) r = r.lt(campo, corteUTC(hasta, 1));
  return r;
}
